import type { LoaderFunction } from 'react-router-dom';
import { redirect } from 'react-router-dom';

import { authRedirectCallback } from '@platform/core/auth';

import { initializeFullStory } from '../../utils/initialize-fullstory/initialize-fullstory';

export const authCallbackLoader: LoaderFunction = async () => {
  const returnTo = await authRedirectCallback();

  await initializeFullStory();

  if (returnTo) {
    // This is to handle external deprecated links and should be removed once they have been updated
    // Enable S2 UIs to create links to UP that includes customer id by setting an 'org' search param
    // Enable Risk portal to create links to UP that includes customer id by setting an 'id' search param
    const orgUrl = new URL(window.location.origin + returnTo);

    const orgIdParam =
      orgUrl.searchParams.get('org') || orgUrl.searchParams.get('id');

    if (orgIdParam) {
      orgUrl.searchParams.delete('org');
      orgUrl.searchParams.delete('id');

      if (!orgUrl.pathname.startsWith(`/${orgIdParam}`)) {
        // Redirect to the url received with the org id as a prefix.
        throw redirect(
          `${orgUrl.origin}/${orgIdParam}${orgUrl.pathname}${orgUrl.search}`,
        );
      } else {
        // Remove the org id from the url
        throw redirect(`${orgUrl.origin}${orgUrl.pathname}${orgUrl.search}`);
      }
    }

    throw redirect(returnTo);
  }

  // redirect to root if there are no auth callback params
  return redirect('/');
};
